<template>
  <transition :enter-active-class="transition.enter" :leave-active-class="transition.leave">
    <div
      role="alert"
      v-show="isActive"
      class="notification-container"
      :class="[`is-${position}`]"
      @click="whenClicked"
    >
      <div class="notification fadeInOut">
        <div class="user-avatar medium">
          <img :src="user.photoURL" v-if="user.photoURL != ''" />
          <i v-if="!user.photoURL" class="stg st-single-neutral-circle-2"/>
        </div>
        <div class="notification-description">
          <span class="hightlight-text">{{user.name}}</span> freut sich auf den Besuch bei 
          <span class="hightlight-text">{{company.name}}</span>.
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { removeElement, HTMLElement } from "./helpers";
export default {
  name: "DonationNotification",
  props: {
    user: {
      default: function() {
        return {
          name: "",
          photoURL: ""
        };
      }
    },
    company: {
      default: function() {
        return {
          name: ""
        };
      }
    },
    position: {
      type: String,
      default: "bottom-right"
    },
    duration: {
      type: Number,
      default: 3000
    },
    dismissible: {
      type: Boolean,
      default: true
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    queue: Boolean,
    container: {
      type: [Object, Function, HTMLElement],
      default: null
    }
  },
  data() {
    return {
      isActive: false,
      parentTop: null,
      parentBottom: null
    };
  },
  computed: {
    correctParent: function() {
      let correctParent;
      switch (this.position) {
        case "top-right":
        case "top":
        case "top-left":
          correctParent = this.parentTop;
          break;
        case "bottom-right":
        case "bottom":
        case "bottom-left":
          correctParent = this.parentBottom;
          break;
      }

      return correctParent;
    },

    transition: function() {
      let transition;
      switch (this.position) {
        case "top-right":
        case "top":
        case "top-left":
          transition = {
            enter: "fadeInDown",
            leave: "fadeOut"
          };
          break;
        case "bottom-right":
        case "bottom":
        case "bottom-left":
          transition = {
            enter: "fadeInUp",
            leave: "fadeOutUp"
          };
          break;
      }
      return transition;
    }
  },
  beforeMount() {
    this.setupContainer();
  },
  mounted() {
    this.showNotice();
  },
  methods: {
    setupContainer() {
      this.parentTop = document.querySelector(".notices.is-top");
      this.parentBottom = document.querySelector(".notices.is-bottom");
      // No need to create them, they already exists
      if (this.parentTop && this.parentBottom) return;
      if (!this.parentTop) {
        this.parentTop = document.createElement("div");
        this.parentTop.className = "notices is-top";
      }
      if (!this.parentBottom) {
        this.parentBottom = document.createElement("div");
        this.parentBottom.className = "notices is-bottom";
      }
      const container = this.container || document.body;
      container.appendChild(this.parentTop);
      container.appendChild(this.parentBottom);
      let containerParentClass = "is-custom-parent";
      if (this.container) {
        this.parentTop.classList.add(containerParentClass);
        this.parentBottom.classList.add(containerParentClass);
      }
    },
    shouldQueue() {
      if (!this.queue) return false;
      return (
        this.parentTop.childElementCount > 0 ||
        this.parentBottom.childElementCount > 0
      );
    },
    close() {
      clearTimeout(this.timer);
      this.isActive = false;
      // Timeout for the animation complete before destroying
      setTimeout(() => {
        this.onClose.apply(null, arguments);
        this.$destroy();
        removeElement(this.$el);
      }, 150);
    },
    showNotice() {
      if (this.shouldQueue()) {
        // Call recursively if should queue
        setTimeout(() => this.showNotice(), 250);
        return;
      }
      this.correctParent.insertAdjacentElement("afterbegin", this.$el);
      this.isActive = true;
      this.timer = setTimeout(() => this.close(), this.duration);
    },
    whenClicked() {
      if (!this.dismissible) return;
      this.onClick.apply(null, arguments);
      this.close();
    }
  }
};
</script>

<style lang="scss">
.notices {
  position: fixed;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2em;
  overflow: hidden;
  z-index: 1052;
  pointer-events: none;

  .notification-container {
    display: inline-flex;
    align-items: center;
    animation-duration: 150ms;
    margin: 0.5em 0;
    pointer-events: auto;
    min-height: 3em;
    cursor: pointer;
  }

  // Individual toast position
  .notification-container {
    &.is-top,
    &.is-bottom {
      align-self: center;
    }

    &.is-top-right,
    &.is-bottom-right {
      align-self: flex-end;
    }

    &.is-top-left,
    &.is-bottom-left {
      align-self: flex-start;
    }
  }

  // Notice container positions
  &.is-top {
    flex-direction: column;
  }

  &.is-bottom {
    flex-direction: column-reverse;
  }

  &.is-custom-parent {
    position: absolute;
  }

  @media screen and (max-width: 768px) {
    padding: 0;
    position: fixed !important;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.fadeInUp {
  animation-name: fadeInUp;
  animation-duration: 4s;
}

@keyframes fadeOutUp {
  from {
    opacity: 1;
    transform: none;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}

.fadeOutUp {
  animation-name: fadeOutUp;
  animation-duration: 4s;
}
</style>